import React, { useContext, useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import { AppContext } from "../../Context/AppContext";
import toast, { Toaster } from "react-hot-toast";
import Backbutton from "../../Components/Header/Backbutton";
import { useNavigate } from "react-router-dom";
import "./ComplaintCategory.css";
import { PulseLoader } from "react-spinners";
import Rating from "@mui/material/Rating";

function AddComplaintCategory() {
  const navigate = useNavigate();
  const { addComplaintCategory, getComplaintCategory, categoryLoading } =
    useContext(AppContext);
  const [categoryValues, setCategoryValues] = useState({
    complaintCategoryName: "",
    complaintCategoryDescription: "",
    score: 0,
  });

  const [error, setError] = useState(false);
  const [reviewLoading, setReviewLoading] = useState(false);

  useEffect(() => {
    let reviewTitle = "⭐️";
    if (categoryValues.score > 0) {
      reviewTitle = "⭐".repeat(categoryValues.score);
      setCategoryValues((prevState) => ({
        ...prevState,
        complaintCategoryName: reviewTitle,
      }));
    }
  }, [categoryValues.score]);

  const formSubmit = async (e) => {
    e.preventDefault();
    if (categoryValues.complaintCategoryDescription.length === 0) {
      setError(true);
      setReviewLoading(false);
      return;
    }

    if (categoryValues.score === 0) {
      toast.error("Please choose rating star!");
      return;
    }

    setReviewLoading(true);

    await addComplaintCategory(categoryValues, {
      onSuccess: async (res) => {
        toast.success("Review Rating created Successfully!");
        setReviewLoading(false);
        // setCategoryValues({
        //   complaintCategoryName: "",
        //   complaintCategoryDescription: "",
        // });

        await getComplaintCategory();

        setTimeout(() => {
          navigate("/complaint-category");
        }, 1000);
      },
      onFailed: (e) => {
        toast.error(e.message);
        setReviewLoading(false);
      },
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCategoryValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className="container-fluid background">
      <Toaster position="top-center" />
      <Header />
      <div className="mains">
        <Toaster position="top-center" />
        <div class="edit-title data mb-3">
          <div class="start-edit">
            <Backbutton />
          </div>
          <div class="center-edit text-center">
            <h4 class="dash-head text-center">Add Review Rating</h4>
          </div>
        </div>
        <div className="add-category" id="review_rating_wrapper">
          <div className="card review_card">
            <form onSubmit={formSubmit}>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  Review Rating
                </label>
                {/* <input
                  type="text"
                  class="form-control"
                  name="complaintCategoryName"
                  value={categoryValues.complaintCategoryName}
                  placeholder="Please Fill Category Name"
                  onChange={handleInputChange}
                /> */}
                <br />
                <Rating
                  size="large"
                  value={categoryValues.score}
                  onChange={(e) => {
                    setCategoryValues((prevState) => ({
                      ...prevState,
                      score: e.target.value,
                    }));
                  }}
                  className="fs-1"
                  disabled={reviewLoading}
                />
                <br />
                {error && categoryValues.score < 0 ? (
                  <span style={{ color: "red" }}>
                    Please fill the Review Rating
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  Description
                </label>
                <input
                  type="text"
                  class="form-control"
                  name="complaintCategoryDescription"
                  value={categoryValues.complaintCategoryDescription}
                  placeholder="Please describe this Review rating is for"
                  onChange={handleInputChange}
                />
                {error &&
                categoryValues.complaintCategoryDescription.length === 0 ? (
                  <span style={{ color: "red" }}>
                    Please fill the description
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="text-center">
                <button type="submit" class="btn btn-danger">
                  {reviewLoading ? (
                    <PulseLoader color="#fff" size={10} />
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddComplaintCategory;
